import React, {useEffect, useState} from 'react'
import {Container, OutlinedInput} from "./styled";
import { DatePicker, DateRangeDelimiter, DateRangePicker } from '@material-ui/pickers'
import moment from "moment";
import { env } from 'env';
const Date = props => {
    const {filter, setFilter} = props.filter
    const [dateTo, setDateTo] = useState(Array.isArray(filter.date) && filter.date[1] ? moment(`${filter.date[1]}`) : moment())
    const [dateFrom, setDateFrom] = useState(Array.isArray(filter.date) && filter.date[0] ? moment(`${filter.date[0]}`) : moment())
		const dateEnv = env.REACT_APP_DATE - 1 || 6
    useEffect(() => {
        setFilter({date: [`${moment(dateFrom).format('YYYY-MM-DD')}`, `${moment(dateTo).format('YYYY-MM-DD')}`], dateTo: `${moment(dateTo).format('YYYY-MM-DD')}`, dateFrom: `${moment(dateFrom).format('YYYY-MM-DD')}`})
    }, [dateTo,dateFrom])

		const handleChangeDate = (newValue) => {
			if(newValue[0]?.isValid() && newValue[1]?.isValid()) {
				if(newValue[1].diff(newValue[0], 'days') <= dateEnv ) {
					setFilter({ date: [newValue[0].format('YYYY-MM-DD'), newValue[1].format('YYYY-MM-DD')] })
				} else {
					setFilter({
						date: [
							newValue[0].format('YYYY-MM-DD'),
							newValue[0].add(dateEnv, 'days').format('YYYY-MM-DD')
						]
					})
				}

			}
		}

    return <Container>
        <h5>{props?.t?.date}</h5>
        {filter.date && <DateRangePicker
            value={filter.date}
            disableFuture={true}
						onChange={handleChangeDate}
            renderInput={(startProps, endProps) => (
                <>
                    <OutlinedInput {...startProps} placeholder='Inicio' />
                    <DateRangeDelimiter>{props?.t?.until}</DateRangeDelimiter>
                    <OutlinedInput {...endProps} />
                </>
            )}
        />}
    </Container>
}

export default Date
